import { inject, InjectionToken } from '@angular/core';
import { NavigationService } from '../services';

export const NAVIGATION_TOKEN: InjectionToken<NavigationProvider> = new InjectionToken<NavigationProvider>(
  'NAVIGATION_TOKEN',
  {
    factory: (): NavigationProvider => {
      const navigationService: NavigationService = inject(NavigationService);

      return {
        init() {
          navigationService.init();
        },
        back() {
          navigationService.back();
        },
        replace(commands: unknown[]) {
          navigationService.replace(commands);
        },
        hasHistory: navigationService.hasHistory,
        previousPage() {
          return navigationService.previousPage();
        }
      };
    }
  }
);

export interface NavigationProvider {
  init(): void;
  back(): void;
  replace(commands: unknown[]): void;
  hasHistory: boolean;
  previousPage(): string;
}
